<template>
	<div class="mainWrapper direct-purchase">
		<h1>Add Product Return to Supplier</h1>
		<div class="form" v-if="suppliers.length > 0">
			<div>
				<span class="label">SUPPLIER</span>
				<b-autocomplete
					v-model="supplierSuggestions"
					:data="filteredSuppliers"
					:open-on-focus="true"
					placeholder="Supplier"
					field="name"
					@select="option => (selectedSupplier = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedSupplier && brands.length > 0">
				<span class="label">BRAND</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
					:disabled="products.length > 0"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div>

			<div v-if="selectedBrand">
				<span class="label">BD CODE</span>
				<div class="addDetails">
					<b-autocomplete
						:data="searchData"
						placeholder="BD Code"
						field="bd_code"
						@typing="searchProducts"
						@select="option => (product = option)"
						class="brandAutocomplete"
					>
						<template slot="empty">No results found</template>
					</b-autocomplete>
				</div>
			</div>

			<div v-if="product">
				<span class="label">ADD</span>
				<b-button type="is-info" icon-left="plus-circle-outline" @click="submit">ADD PRODUCT</b-button>
			</div>
		</div>

		<div class="form" v-if="selectedSupplier && selectedBrand">
			<div>
				<span class="label">RETURN TYPE</span>
				<b-select v-model="selectedReturnType" placeholder="Select reason for return" expanded>
					<option value="damaged">Damaged</option>
					<option value="expired">Expired</option>
					<option value="stock">Stock</option>
					<option value="tester">Tester</option>
				</b-select>
			</div>
		</div>

		<div class="list">
			<div class="products-list header">
				<div>
					BD CODE
				</div>

				<div>
					BARCODE
				</div>

				<div>
					NAME
				</div>

				<div>
					PACKAGING
				</div>

				<div>
					QUANTITY
				</div>
			</div>

			<div v-for="(item, index) of products" v-bind:key="index" class="products-list">
				<div>
					{{ item.bd_code }}
				</div>

				<div>
					{{ item.barcode }}
				</div>

				<div>
					{{ item.name }}
				</div>

				<div>
					<b-select v-model="item.packaging_selection" disabled>
						<option :value="item.packaging_selection">
							{{ getPackagingSelectionDisplay(item) }}
						</option>
					</b-select>
				</div>

				<div>
					<input name="qtyInput" class="qtyInput" type="number" v-on:change="update(index, 'qty', $event.target.value)" />
				</div>
			</div>
		</div>

		<div v-if="products.length > 0" class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="save()">SAVE</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CreatePurchaseOrder',
	data: function() {
		return {
			warehouse: null,
			suppliers: [], // List of suppliers from API
			selectedSupplier: null, // Selected supplier
			supplierSuggestions: '', // Supplier autocomplete suggestions
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			selectedReturnType: null, // Selected return type
			bdcodeData: [], // API bdcode data
			searchData: [], // API Search data
			brandSuggestions: '', // List of brands
			product: null, // 1 selected product
			products: [], // Selected products
			name: null
		}
	},
	computed: {
		filteredSuppliers() {
			return this.suppliers.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.supplierSuggestions.toLowerCase()) >= 0
				)
			})
		},
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		// product: function(newData) {
		// 	console.log(newData)
		// },

		selectedSupplier: function(newData) {
			this.selectedBrand = null
			this.selectedReturnType = null
			this.product = null
			this.products = []
			this.brands = []

			if (newData) {
				// Load brands for selected supplier
				this.brands = newData.brand || []
			}
		},

		selectedBrand: function(newData) {
			this.product = null
			this.products = []
		}
	},

	mounted: async function() {
		// Get current warehouse info
		const warehouseData = {
			populate: ['suppliers']
		}
		const apiGetWarehouse = await this.$api.getWarehouse({ data: warehouseData })
		this.warehouse = apiGetWarehouse.data

		// Get list of suppliers with brands populated
		const supplierData = {
			populate: ['brand']
		}
		const apiGetSuppliers = await this.$api.getSuppliers({ data: supplierData })
		this.suppliers = apiGetSuppliers.data.list || []
	},

	methods: {
		save: async function() {
			// Validate that return type is selected
			if (!this.selectedReturnType) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Please select a return type'
				})
				return
			}

			var newData = []

			this.products.map(product => {
				var productData = {}
				productData.product = product._id
				productData.qty = product.qty

				// Add packaging selection with fallback priority
				productData.packaging_selection = product.packaging_selection || this.getPackagingSelection(product)

				newData.push(productData)
			})

			const data = {
				supplier: this.selectedSupplier._id,
				brand: this.selectedBrand._id,
				warehouse: this.warehouse._id,
				return_product_items: newData,
				type: [this.selectedReturnType], // Pass as array with selected return type
				return_type: 'warehouse_to_supplier'
			}

			const apiCreateRP = await this.$api.addProductReturn({ data })

			if (apiCreateRP !== undefined) {
				this.$swal.fire(apiCreateRP.data.return_product.code)

				this.$router.push('/returns')
			}
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		submit: async function() {
			// Initialize product properties
			this.product.qty = null

			// Auto-select packaging based on priority: packaging.base_unit -> original_price_unit -> single_item
			this.product.packaging_selection = this.getPackagingSelection(this.product)

			this.products.push(this.product)

			// Reset form after adding product
			this.product = null
			this.searchData = []
		},

		update: function(index, item, value) {
			if (item == 'qty') {
				this.products[index].qty = Number(value)
			}
		},

		// Autocomplete search
		searchProducts: async function(name) {
			if (name.length > 1) {
				const data = {
					brand: this.selectedBrand._id,
					bd_code: name
				}

				const apiSearchProduct = await this.$api.searchProduct({ data })

				this.searchData = apiSearchProduct.data.list

				// If no data found, try to search with barcode
				if (apiSearchProduct.data.list && apiSearchProduct.data.list.length < 1) {
					delete data.bd_code

					data.barcode = name

					const apiSearchProduct = await this.$api.searchProduct({ data })

					this.searchData = apiSearchProduct.data.list
				}
			}
		},

		// Get packaging selection with fallback priority: packaging.base_unit -> original_price_unit -> single_item
		getPackagingSelection: function(product) {
			// First priority: packaging.base_unit
			if (product && product.packaging && product.packaging.base_unit) {
				return product.packaging.base_unit
			}
			// Second priority: original_price_unit
			if (product && product.original_price_unit) {
				return product.original_price_unit
			}
			// Final fallback: single_item
			return 'single_item'
		},

		// Get packaging selection display text for the dropdown
		getPackagingSelectionDisplay: function(product) {
			// First priority: packaging.base_unit
			if (product && product.packaging && product.packaging.base_unit) {
				return product.packaging.base_unit
			}
			// Second priority: original_price_unit
			if (product && product.original_price_unit) {
				return product.original_price_unit
			}
			// Final fallback: single_item
			return 'single_item'
		}
	}
}
</script>

<style scoped>
@import '../styles/AddPurchaseOrder.css';
</style>
